import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../Components/Table";
import Api from "../../Hooks/Api";
const IncidentTypes = (props) => {

    
    const [RowData, setRowData] = useState([]);
    const url = "api/incidentTypes"; 

    const setIncidentsdata = async (data) => {       
        const rows = data?.incidentTypes || [];                 
                
                rows.forEach((k) => {
                    const Rowdata = { 
                        id:k.id,
                        name: k.name,                        
                        description:k.description
                    }; 
                    setRowData((inputs) => [ ...inputs, Rowdata ]);
                        
                });
            
    }
    const FetchAll = async () => { 
        setRowData([]);
        try {
            Api.get(url + "/getAll?page=0&size=1")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setIncidentsdata(data); 
                const totalPages = data.totalPages;   
                for (let i = 0; i < totalPages; i++) {  
                    let nextPage=parseFloat(i) + parseFloat(1) ;       
                    Api.get(url + "/getAll?page="+nextPage+"&size=1")
                    .then(function (response) {                        
                      if (response.status=== 200) {
                        const data =response.data;
                        setIncidentsdata(data); 
                      }
                    })
                    .catch(function (error) {
                    })
                    .then(function () {
                      // always executed
                    }) 
                }
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })

            

            
        } catch (error) {
            console.error("Error fetching securityIncidents:", error);
        }
    }; 
    useEffect(() => {
        FetchAll();   
    }, []);

  

    const ColumnData = [
        { label: "Id", field: "id", sort: "asc" },
        { label: "Name", field: "name", sort: "asc" },
        { label: "Description", field: "description", sort: "asc" }

    ];
   
    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Security Incidents Types</li>
            </ol>
            <h1 className="page-header mb-3">Security Incidents Types</h1>
            <div style={{ backgroundColor: "white" }}>
               
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={ColumnData} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncidentTypes;
